import { LoaderOptions } from '@googlemaps/js-api-loader'

const GOOGLE_API: LoaderOptions = {
  apiKey: 'AIzaSyC3TtAFtyUtSOP0bMjc3eIgXAPNBOZyS9g',
  libraries: ['places', 'geometry'],
  id: 'MainSearchFieldAPI',
}
export default GOOGLE_API
